@let devices = devices$ | async;
<mat-list class="device-list">
  @if (isLoading) {
    @for (data of skeletonData; track $index) {
      <!-- Skeleton Loader -->
      <div class="device-card device-card-normal">
        <div class="device-card-header">
          <ngx-skeleton-loader count="1" [theme]="{ width: '200px', height: '24px' }"></ngx-skeleton-loader>
        </div>

        <div class="device-card-body">
          <div class="device-attributes">
            <ngx-skeleton-loader count="2" [theme]="{ width: '100px', height: '16px' }"></ngx-skeleton-loader>
          </div>
          <div class="device-values">
            <ngx-skeleton-loader count="2" [theme]="{ width: '160px', height: '20px' }"></ngx-skeleton-loader>
          </div>
        </div>

        <div class="device-card-buttons">
          <ngx-skeleton-loader count="1" [theme]="{ width: '80px', height: '36px' }"></ngx-skeleton-loader>
        </div>
      </div>
    }
  }
  @for (device of devices; track device.device_id) {
    <div class="device-card device-card-normal" [attr.data-testid]="'deviceCard' + $index">
      <div class="device-card-header" [attr.data-testid]="testIds.deviceCardHeader">
        <span class="device-number" [attr.data-testid]="testIds.deviceCardNumber">{{ $index + 1 }}.</span>
        <span class="device-name" id="name-span" [attr.data-testid]="testIds.deviceCardHeaderName">
          {{ device.display_name }}
        </span>
      </div>
      <div class="device-card-body" [attr.data-testid]="testIds.deviceCardBody1">
        <div class="device-attributes">
          <span>IP-Adresse</span>
          <span>Device ID</span>
        </div>
        <div class="device-values">
          <span [attr.data-testid]="testIds.deviceCardIpValue">{{ device.last_seen_ip }}</span>
          <span [attr.data-testid]="testIds.deviceCardDeviceIdValue">{{ device.device_id }}</span>
        </div>
      </div>
      <hr class="divider" [attr.data-testid]="testIds.dividerTitle" />
      <div class="device-card-body" [attr.data-testid]="testIds.deviceCardBody2">
        <div class="device-attributes">
          <span>Zeitstempel</span>
        </div>
        <div class="device-values">
          <span [attr.data-testid]="testIds.deviceCardLastSeenValue">{{
            device.last_seen_ts | date: 'dd.MM.yyyy, HH:mm:ss'
          }}</span>
        </div>
      </div>
      <div class="device-card-buttons">
        <app-button
          [isPrimary]="true"
          class="device-button"
          [dataTestId]="testIds.deviceCardButtonDelete"
          (click)="deleteDevice(device)"
          (keydown)="$event.stopPropagation()"
          text="Löschen"></app-button>
      </div>
    </div>
  } @empty {
    <span class="no-devices">Keine Devices vorhanden</span>
  }
</mat-list>
<div class="footer-btn">
  <app-button
    [isPrimary]="true"
    [attr.data-testid]="testIds.deleteAllBtn"
    text="Alle Löschen"
    [isDisabled]="!devices || devices.length === 0"
    (keydown)="$event.stopPropagation()"
    (click)="deleteAllDevices(devices)"></app-button>
</div>
